import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=25f1ec1e&scoped=true&"
import script from "./Recognition.vue?vue&type=script&lang=js&"
export * from "./Recognition.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Recognition.vue?vue&type=style&index=1&id=25f1ec1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1ec1e",
  null
  
)

export default component.exports